var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"now-line",class:_vm.darkMode ? 'dark' : '',style:({ transform: 'translateX(calc(480rem * ' + _vm.percentThroughDay + ')' })})}
var staticRenderFns = []

export { render, staticRenderFns }